
webpack.register(
    'modules/vc-featured-block/vc-featured-block',
    function() {
        return import('modules/vc-featured-block/vc-featured-block');
    },
    true
);